/**
 * Decorative layers for the app shell. aria-hidden and non-interactive; the dot colour follows the theme
 * (--app-pattern in themes.css). Cards (`surface-card`) are solid and sit on top of the dots.
 */

/** Dot texture for the sidebar rail, strongest at the top and bottom, plus a soft gradient edge. */
export function SidebarPattern() {
  return (
    <>
      <div
        aria-hidden
        className="pattern-dots pointer-events-none absolute inset-0 [--app-pattern:var(--app-sidebar-pattern)] [mask-image:linear-gradient(to_bottom,black,transparent_35%,transparent_70%,black)]"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 right-0 w-px bg-gradient-to-b from-transparent via-line-strong to-transparent"
      />
    </>
  )
}

/** Dot pattern covering the whole content area (behind the top bar and pages). Scrolls with the page. */
export function ContentBackdrop() {
  return <div aria-hidden className="pattern-dots pointer-events-none absolute inset-0 -z-10" />
}
